import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Conversation: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    {...props}
  >
    <style>{'.st0{fill:#002677}.st1{fill:#ff612b}'}</style>
    <g>
      <path
        d="M21.883 11.336c-1.247 3.408-.294 6.689 1.822 8.805a8.101 8.101 0 0 0 5.748 2.38h2.955v4.34c0 .325.383.5.628.287l7.396-6.401.399-.34c.03-.03.066-.059.096-.088a8.09 8.09 0 0 0 2.563-5.926 8.101 8.101 0 0 0-2.379-5.747 8.101 8.101 0 0 0-5.748-2.38h-5.956c-3.306 0-6.388 1.966-7.524 5.07z"
        className="st0"
      />
      <path
        d="M27.237 18.087h9.604a.739.739 0 1 0 0-1.478h-9.604a.739.739 0 0 0 0 1.478zM27.237 15.132h9.604a.739.739 0 1 0 0-1.478h-9.604a.739.739 0 0 0 0 1.478zM27.237 12.177h9.604a.739.739 0 1 0 0-1.478h-9.604a.739.739 0 0 0 0 1.478zM20.388 18.075H13.67a9.138 9.138 0 0 0-6.483 2.683 9.137 9.137 0 0 0-2.684 6.483 9.124 9.124 0 0 0 2.892 6.683c.033.034.075.067.108.1l.45.384 8.341 7.22c.278.24.709.043.709-.324v-4.896h3.333a9.138 9.138 0 0 0 6.483-2.684c2.387-2.387 3.462-6.087 2.056-9.93-1.282-3.503-4.757-5.719-8.487-5.719z"
        className="st1"
      />
      <path
        d="M22.836 31.408H12.003a.833.833 0 0 1 0-1.667h10.833a.834.834 0 0 1 0 1.667zM22.836 28.075H12.003a.833.833 0 0 1 0-1.667h10.833a.834.834 0 0 1 0 1.667zM22.836 24.742H12.003a.833.833 0 0 1 0-1.667h10.833a.834.834 0 0 1 0 1.667z"
        className="st0"
      />
    </g>
  </Box>
)
export default Conversation
